import { useEffect, useState } from 'react'
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore'
import { db } from '@/config/firebase'
import type { UserDoc } from '@/types/user'

export interface UserRecord extends UserDoc {
  id: string
}

interface UsersState {
  users: UserRecord[]
  loading: boolean
  error: string | null
}

/** Realtime list of all users (admins only, per firestore.rules). */
export function useUsers(): UsersState {
  const [state, setState] = useState<UsersState>({ users: [], loading: true, error: null })

  useEffect(() => {
    const usersQuery = query(collection(db, 'users'), orderBy('name'))
    const unsubscribe = onSnapshot(
      usersQuery,
      (snapshot) => {
        const users = snapshot.docs.map((docSnap) => ({
          id: docSnap.id,
          ...(docSnap.data() as UserDoc),
        }))
        setState({ users, loading: false, error: null })
      },
      (error) => {
        setState({ users: [], loading: false, error: error.message })
      },
    )
    return unsubscribe
  }, [])

  return state
}
